export default __webpack_public_path__ + "static/media/icon-engyj-app.7cd650d4.svg";